import {
  ClientValidator,
  FieldErrors,
  Fieldset,
  FieldSuggestions,
  FieldValues,
  FormConfig,
  HistoryEntry,
  SchemaExtras,
  TopAlert
} from '~/models/classified/form'
import { v4 as uuid } from 'uuid'
import { CompactPage } from '~/models/common/types'
import { SuggestedCategory } from '~/models/search/types'
export const CLASSIFIED_FORM_NS = 'classifieds/form'

export interface FormState {
  config: FormConfig
  categoryId: number | null
  allCategories: any[]
  categoryIds: number[]
  rootCategoryId: number | null
  classifiedId?: number
  fieldsets: Fieldset[]
  title: string
  fieldErrors: FieldErrors
  fieldValues: FieldValues
  fieldSuggestions: FieldSuggestions
  genericFormFields: any
  loading: boolean
  schemaLoading: boolean
  editMode: boolean
  uniqueFormId: string
  pageKey: string
  page: CompactPage
  extras?: SchemaExtras
  topAlert: TopAlert
  history: HistoryEntry[]
  historyActiveIndex: number
  clientValidators: ClientValidator[]
  invalidTriggered: boolean
  telephones: { telephone: string }[]
  requiresPayment: boolean
  termsAccepted: boolean
  suggestedCategory: SuggestedCategory | null
  pendingDescription: string
  warningConfirmationMessage: {
    title: string
    text: string
  }
  isWarningConfirmationVisible: boolean
}

function getDefaultState(): FormState {
  return {
    categoryId: null,
    categoryIds: [],
    allCategories: [],
    rootCategoryId: null,
    classifiedId: undefined,
    config: {
      settings: {
        fieldColumns: {}
      }
    },

    fieldsets: [],
    title: '',
    fieldErrors: {},
    fieldValues: {},
    fieldSuggestions: {},
    genericFormFields: [],
    loading: false,
    schemaLoading: false,
    editMode: false,
    uniqueFormId: uuid(),
    pageKey: '',
    page: {
      breadcrumbs: [],
      metadata: [],
      seoUrl: '',
      title: '',
      externalUrl: '',
      targetSeoUrl: ''
    },
    extras: undefined,
    topAlert: {
      variant: 'info',
      message: ''
    },
    history: [],
    historyActiveIndex: -1,
    clientValidators: [],
    invalidTriggered: false,
    telephones: [],
    requiresPayment: false,
    termsAccepted: false,
    suggestedCategory: null,
    pendingDescription: '',
    warningConfirmationMessage: {
      title: '',
      text: ''
    },
    isWarningConfirmationVisible: false
  }
}

export default getDefaultState
